<template>
  <div style="padding-top: 60px">
    <popup :message="alertErrMessage" v-if="isAlertErr" @close="isAlertErr = false" />
    <div>
      <div class="head-class" ref="ctn_head">
        <div class="left">
          <div class="d-flex mt-10">
            <div v-for="(tag, index) in $t('bootcampDetail.heroSection.tags')" :key="index"
              class="btn-alice-blue-oval font-poppins">
              {{ tag }}
            </div>
          </div>

          <h1 class="text-banner">{{ classDetail.name }}</h1>
          <p class="description-class">
            {{ $t('bootcampDetail.heroSection.subHeading') }}
          </p>
          <!-- <div>
            <span style="font-size:12px;color: #7B7E8C;">Didukung sertifikasi global</span>
            <div class="d-flex align-center">
              <img src="/img/bootcamp/aca.png" alt="" style="width: 48px; border-radius: 16px;">
              <span class="ml-3">Alibaba Cloud Associate (ACA) Developer</span>
            </div>
          </div> -->
          <v-btn depressed @click="goToCheckoutPage('register')" class="button-daftar">
            <div>
              <span class="text-capitalize font-weight-bold font-poppins" >
              {{ $t('bootcampDetail.heroSection.ctaButtons.registerNow') }}
            </span><br><span style="text-transform: none">{{ $t('bootcampDetail.heroSection.ctaButtons.only') }} Rp1.699.000,-</span>
            </div>
          </v-btn>
        </div>
        <img :src="classDetail.image_url" class="img-banner-1" />
      </div>
      <div class="box-radius">
        <div v-for="(menu, idx) in menuPublicClass" :key="menu.id" class="menu-detail"
          @click="clickActiveMenu(menu.layout, menu.position, menu.name)">
          <span>{{ $t(`bootcampDetail.menuPublicClass[${idx}].name`) }}</span>
          <div :class="{ linesmall: layout === menu.layout }"></div>
        </div>

        <v-btn depressed @click="goToCheckoutPage('register')" class="button-daftar" v-if="!isRegistrantClose">
            <div>
              <span class="text-capitalize font-weight-bold font-poppins" >
              {{ $t('bootcampDetail.heroSection.ctaButtons.registerNow') }}
            </span><br><span style="text-transform: none">{{ $t('bootcampDetail.heroSection.ctaButtons.only') }} Rp1.699.000,-</span>
            </div>
          </v-btn>
      </div>
      <!-- Rest of the template remains unchanged -->
      <div style="margin-top: -480px; padding-top: 50px;">
        <div class="container-parent" style="" ref="overview">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.sections.overview.subtitle') }}</span>
            <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.sections.overview.title') }}
            </h5>
            <p class="mt-5" style="text-align: justify;color: #575966; font-size: 1rem;" v-html=" $t('bootcampDetail.sections.overview.desc')"></p>
          </div>
        </div>

        <div class="container-parent" style="padding: 50px 0" ref="curriculum">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.sections.curriculum.title') }}</span>
            <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.sections.curriculum.subtitle') }}
            </h5>
            <div class="d-flex">
              <div class="d-flex align-center mt-5" v-for="(i, phase) in curriculums" :key="phase">
                <v-btn outlined style="border-radius: 40px;" class="btn-oval-with-width mr-2" @click="getCurriculum(i.id - 1)" :class="{ 'bg-full-active': curriculumActive === i.id }">
                  Fase {{ i.id }}
                </v-btn>
                <div v-if="i.id != '4'" style="height: 1px;width: 30px; background-color: #36373F;" class="mr-2"></div>
              </div>
            </div>

            <div class="timeline-bootcamp mt-5">
              <h5>Bootcamp Fase {{ this.tempCurriculums.id }}</h5>
              <h3 class="mt-2">{{ this.tempCurriculums.title }}</h3>
              <p class="mt-2" v-html="tempCurriculums.desc"></p>

              <h4 class="mt-7 mb-3">Materi yang akan dipelajari</h4>
              <div style="color: #36373F;">
                <div class="d-flex align-center" style="background-color: #FFDE59;height: 40px;color: #36373F;font-weight: 600;font-size: 14px;border-top-left-radius: 8px; border-top-right-radius: 8px;">
                  <img src="/img/bootcamp/ic_hardskill.png" width="24" class="ml-3"/>
                  <span class="ml-3">Hardskill</span>
                </div>
                <div style="background-color: white;" class="pl-3 pt-5 pb-5">
                  <ul>
                    <li v-for="(i, list) in tempCurriculums.material.categories[0].detail" :key="list">
                      <span style="font-weight: 700;">{{ i.title }}</span> <br> <p v-html="i.desc"></p>
                    </li>
                  </ul>
                </div>

                <div class="d-flex align-center mt-5" style="background-color: #FFDE59;height: 40px;color: #36373F;font-weight: 600;font-size: 14px;border-top-left-radius: 8px; border-top-right-radius: 8px;">
                  <img src="/img/bootcamp/ic_softskill.png" width="24" class="ml-3"/>
                  <span class="ml-3">Softskill</span>
                </div>

                <div style="background-color: white;" class="pl-3 pt-5 pb-5">
                  <p v-html="this.tempCurriculums.material.categories[1].detail[0].desc"></p>
                </div>
              </div>

              <h4 class="mt-7 mb-3">Tools Yang digunakan</h4>
              <div class="d-flex align-center">
                <div class="mr-3 align-center d-flex" v-for="(i, image) in tempCurriculums.tools" :key="image" style="background: white;width: 120px;height: 56px;">
                  <div style="margin: auto;"><img :src="$utils.loadImage(i.img)" width="45"/></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-parent" style="margin-top: -30px;margin-bottom: 50px;">
        <div class="container-detail pa-5 d-flex" style="background-color: #FFDE59;border-radius: 8px;">
          <div>
            <span>Pelajari informasi lebih lengkap dengan dapatkan</span> <span style="color: #162CA2;font-weight: 700;">silabus Fullstack Web Development with AI Integration.</span>
          </div>
          <v-btn depressed color="#162CA2" class="box-cta-daftar" @click="goToCheckoutPage('syllabus')">
              <span class="text-capitalize white--text" style="font-size: 14px; letter-spacing: 0 !important;font-weight: 600;">
                UNDUH SILABUS
              </span>
            </v-btn>
        </div>
      </div>

      <div style="margin-bottom: -14px; padding-bottom: 20px;padding-top: 30px;">
        <div class="container-parent" ref="taget_peserta">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.targetAudience.title') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.targetAudience.subtitle') }}
            </h5>
            <div class="target-participant-parent">
              <div v-for="(i, targetParticipant) in $t('bootcampDetail.targetParticipants')" :key="targetParticipant" class="target-participant-child">
                <img :src="$utils.loadImage(i.icon)" style="border-radius: 6px;" alt="ENG" width="40" height="40" />
                <h3 class="mt-3">{{ i.title }}</h3>
                <p style="font-size: 1rem;color: rgba(87, 89, 102, 1);">{{ i.desc }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="container-parent mt-10" ref="instructor" style="padding: 50px 0">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.instructorSection.title') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.instructorSection.subtitle') }}
            </h5>
            <div class="mentor-card d-flex mt-5" v-for="(data, idx) in instructor" :key="idx">
              <div class="d-flex">
                <img :src="$utils.loadImage(data.image_url)" alt=""
                  style="width: 30%; border-radius: 8px 0 0 8px;object-fit: cover;" />
                  <div class="pa-5">
                    <div class="mb-3" style="font-size: 16px;"><span class="bold">{{ data.name }}</span></div>
                    <div class="d-flex align-center mb-2">
                      <img src="/img/bootcamp/ic_checklist.png" width="24" />
                      <div class="ml-2"><span>Alibaba Cloud Certified Professional</span></div>
                    </div>
                    <p v-html="data.description"></p>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-parent" ref="why_hicolleagues" style="padding-top: 20px">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.sections.whyHiColleagues.title') }}</span>
            <h5 class="title" style="
                font-family: 'Poppins', sans-serif !important;
                line-height: 30px;
              ">
              {{ $t('bootcampDetail.sections.whyHiColleagues.subtitle') }}
            </h5>
            <div class="why-hicoll mt-8">
              <div v-for="(item, idx) in $t('bootcampDetail.whyHiColl')" :key="idx">
                <div class="circle-yellow">
                   <img :src="item.img" width="24" alt="Ctn" />
                </div>
                <h3 class="mt-3">{{ item.title }}</h3>
                <p style="color: rgba(87, 89, 102, 1);font-size: 1rem;">{{ item.desc }}</p>

                <!-- <div v-if="item.key === 'certification'" class="d-flex align-center">
                  <img src="/img/bootcamp/aca.png" alt="" style="width: 64px;">
                  <span class="ml-3" style="font-weight: 600;">Alibaba Cloud Associate (ACA) Developer</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="container-parent mt-15 pt-15" ref="timeline_belajar">
          <div class="container-detail">
            <span class="addional">{{ $t('bootcampDetail.scheduleSection.title') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.scheduleSection.subtitle') }}
            </h5>
            <div class="timeline-bootcamp mt-5" v-for="(item, idx) in classDetail.schedules" :key="idx">
              <div class="d-flex justify-space-between">
                <div>
                  <div class="d-flex align-center" style="height: 50px;">
                  <p class="batch mr-3">Batch {{ item.batch_number }}</p>
                  <div class="d-flex justify-space-between align-center label-quota">
                    <div class="pt-1"><img src="/img/bootcamp/ic_verified.png" alt="" style="width: 16px;"></div>
                    <span>Kuota Tersedia</span>
                  </div>
                </div>
                <span class="bold">{{ formatDateInfo(item.start_date) }} - {{ formatDateInfo(item.end_date) }}</span>
                </div>

              </div>
              <v-divider class="mt-7 mb-5"></v-divider>
              <div class="info-schadule">
                <div class="info-schadule-ctn">
                  <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.totalDuration') }}</span>
                  <span class="bold">{{
                    $utils.getMonthDifference(item.start_date, item.end_date) }}</span>
                </div>
                <div class="info-schadule-ctn" style="margin-left: -30px;">
                  <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.classSchedule') }}</span>
                  <span class="bold">{{ classDetail.days }}</span>
                  <span class="sm">{{ classDetail.hours }}</span>
                </div>
                <div class="info-schadule-ctn">
                  <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.totalSession') }}</span>
                  <span class="bold">{{ item.session }} {{
                    $t('bootcampDetail.scheduleSection.labels.session') }}</span>
                </div>

                <div class="info-schadule-ctn" style="text-align: right;">
                  <span class="sm">Nilai Program</span>
                  <h3> {{ classDetail.price | toCurrency }}</h3>
                </div>

                  
              </div>

              <v-divider class="mt-7 mb-5"></v-divider>
              <div>
                <!-- BOX RINCIAN -->
                <div class="rincian-box">
                  <div class="rincian-row pt-4">
                    <span class="rincian-label" style="font-weight: bold;">RINCIAN BEASISWA PARSIAL</span>
                  </div>
                  <div class="rincian-row">
                    <span class="rincian-label">
                      Subsidi Beasiswa
                      <span class="parsial-tag">Parsial</span>
                    </span>
                    <span class="rincian-value">− {{ 27301000 | toCurrency }}</span>
                  </div>
                  <div class="rincian-row">
                    <span class="rincian-label">Kontribusi Kamu</span>
                    <span style="color: #162CA2;font-size: 24px;font-weight: bold;">{{ 1699000 | toCurrency }}</span>
                  </div>
                  
                </div>
                <!-- <v-btn depressed @click="goToCheckoutPage('register')" class="button-daftar" style="width: 100%;margin-top: 10px;">
                  <div>
                    <span class="text-capitalize font-weight-bold font-poppins" >
                    {{ $t('bootcampDetail.heroSection.ctaButtons.registerNow') }}
                  </span><br><span style="text-transform: none">{{ $t('bootcampDetail.heroSection.ctaButtons.only') }} Rp1.699.000,-</span>
                  </div>
                </v-btn> -->
              </div>

              <v-divider class="mt-7 mb-5"></v-divider>

              <div style="font-size: 14px;line-height: 30px;">
                <span class="bold">{{ $t('bootcampDetail.scheduleSection.benefit.seeBenefit') }}</span>
                <div v-for="(i, benefit) in $t('bootcampDetail.scheduleSection.benefit.detailBenefit')" :key="benefit">
                  <ul>
                    <li v-html="i.desc"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Belum ada payment method sehingga di hide dulu -->
          <!-- <div class="container-detail mt-10">
            <span class="addional">{{ $t('bootcampDetail.paymentMethodSection.title') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.paymentMethodSection.subtitle') }}
            </h5>
            <div class="cada-parent">
              <div v-for="(data, idx) in $t('bootcampDetail.paymenMethod')" :key="idx" class="card-sayhay">
                <components :is="data.icon"></components>
                <h3>{{ data.title }}</h3>
                <p style="font-size: 14px" class="mt-4">{{ data.desc }}</p>
                <div style="height: 45px;"></div>
                <div style="position: absolute; bottom: 32px;">
                  <div class="btn-stoke-blue" v-if="data.btn">
                    <span class="font-poppins" style="font-size: 13px;">{{ $t('bootcampDetail.a2') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="container-parent" ref="faq" style="margin: 50px 0">
          <div class="container-detail">
            <span class="addional">{{ $t('publicTrainingDetail.faqSection.subtitle') }}</span>
            <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
              {{ $t('bootcampDetail.a1') }}
            </h5>
            <div class="faq" style="margin-top: 10px;">
              <v-expansion-panels class="faq-card">
                <v-expansion-panel v-for="(item, index) in questions" :key="index"
                  style="border-radius: 20px; padding: 0px; margin-bottom: 10px;">
                  <v-expansion-panel-header disable-icon-rotate @click="openFaq(index)"
                    style="padding: 0px 0px 0px 20px !important">
                    <h2 style="margin: 25px 0; font-size: 1rem; line-height: 31px;">{{ item.title }}</h2>
                    <template v-slot:actions>
                      <div class="icon" v-if="item.active">
                        <Arrow style="margin-right: 35px;" />
                      </div>
                      <div v-else>
                        <Arrow :down="!item.active" style="margin-right: 35px;" />
                      </div>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-html="item.description"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div style="padding: 25px 10px;">
                <div class="btn-stoke-blue cursor-pointer" @click="goToFaqPage"
                  style="margin: 0; padding: 10px 25px; gap: 10px; background-color: white">
                  <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
                  <ArrowLong />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import goTo from "vuetify/lib/services/goto";
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import Arrow from "@/assets/icons/Arrow.vue";
import Popup from "@/components/others/Popup.vue";

export default {
    name: "DetailBootcampDekstop",
    components: {
    Arrow,
    Popup,
    ArrowLong,
  },
  data() {
    return {
      curriculumActive: 1,
      tempCurriculums: {
        id: 1, title: 'Fundamental Programming & Pengenalan Ekosistem', desc: 'Anda akan membangun fondasi yang kokoh dalam <b>logika pemrograman universal</b> sebelum menyelami bahasa spesifik. Serta memahami cara kerja algoritma, struktur data dasar, dan alur kontrol. Sehingga dalam fase ini anda mampu membuat program Go CLI sederhana, dan aplikasi Vue.js frontend dasar.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Pengenalan dasar bahasa Go, sintaks, tipe data, dan kontrol aliran. Anda akan membuat aplikasi Command Line Interface (CLI) sederhana.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Mempelajari dasar-dasar Vue.js untuk membangun antarmuka pengguna interaktif, termasuk konsep komponen, data binding, dan event handling. Anda akan membuat aplikasi frontend sederhana (tanpa backend).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan <b>komunikasi efektif</b>, memahami <b>etika profesional</b>, dan menumbuhkan <b>growth mindset</b> untuk pembelajaran berkelanjutan.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_vuejs.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_html.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_css.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_js.png'},
          ]
      },
      curriculums: [
        {
          id: 1, title: 'Fundamental Programming & Pengenalan Ekosistem', desc: 'Anda akan membangun fondasi yang kokoh dalam <b>logika pemrograman universal</b> sebelum menyelami bahasa spesifik. Serta memahami cara kerja algoritma, struktur data dasar, dan alur kontrol. Sehingga dalam fase ini anda mampu membuat program Go CLI sederhana, dan aplikasi Vue.js frontend dasar.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Pengenalan dasar bahasa Go, sintaks, tipe data, dan kontrol aliran. Anda akan membuat aplikasi Command Line Interface (CLI) sederhana.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Mempelajari dasar-dasar Vue.js untuk membangun antarmuka pengguna interaktif, termasuk konsep komponen, data binding, dan event handling. Anda akan membuat aplikasi frontend sederhana (tanpa backend).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan <b>komunikasi efektif</b>, memahami <b>etika profesional</b>, dan menumbuhkan <b>growth mindset</b> untuk pembelajaran berkelanjutan.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_vuejs.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_html.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_css.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_js.png'},
          ]
        },
        {
          id: 2, title: 'Pengembangan Core & Interaksi', desc: 'Anda akan membangun aplikasi yang saling terhubung antara backend dan frontend. Sehingga dalam fase ini anda mampu membuat RESTful API Go yang terhubung database, dan aplikasi Vue.js frontend yang berinteraksi dengan API tersebut secara dinamis.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Mempelajari cara membangun <b>RESTful API</b> menggunakan Go, termasuk routing, penanganan request/response, dan <b>integrasi database SQL</b> untuk operasi CRUD (Create, Read, Update, Delete). Anda akan membuat backend API yang berfungsi penuh.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Menguasai <b>manajemen state</b> aplikasi dengan Vuex/Pinia dan <b>routing</b> menggunakan Vue Router untuk membuat Single Page Application (SPA). Anda juga akan belajar cara berinteraksi dengan API yang sudah dibuat (mengambil, mengirim, mengedit, menghapus data).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengasah kemampuan <b>kolaborasi tim</b> melalui penggunaan Git dan prinsip Agile dasar, serta meningkatkan skill <b>pemecahan masalah</b> dan debugging.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_github.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_postgres.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_postman.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        },
        {
          id: 3, title: 'Optimasi, Skalabilitas, & Profesionalisme', desc: 'Anda akan meningkatkan kualitas, performa, dan keamanan aplikasi, serta merancang arsitektur yang lebih baik. Dalam fase ini, Anda tidak hanya akan mengoptimalkan aplikasi yang sudah ada, tetapi juga mulai mengintegrasikan kecerdasan buatan. Anda akan belajar bagaimana membangun Aplikasi Go API yang teruji, aman dengan autentikasi, dan aplikasi Vue.js yang canggih dan responsif, siap untuk tahapan deployment, serta mampu mengintegrasikan fitur AI.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Mendalami <b>arsitektur aplikasi</b> (layered architecture), <b>pengujian (Unit Testing)</b> yang komprehensif, konsep <b>concurrency (Goroutines & Channels)</b> untuk aplikasi yang lebih efisien, dan implementasi <b>autentikasi (JWT)</b>.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Membangun komponen lanjutan yang reusable, mengelola state yang kompleks, pengujian frontend (Unit Testing), dan optimasi performa aplikasi Vue.js. Anda juga akan mengenal penggunaan <b>UI Frameworks.</b>'
                  },
                  {
                    id: 3, title: 'Integrasi AI', desc: 'Anda akan mempelajari dasar-dasar <b>integrasi OpenAI API</b> untuk menambahkan fitur kecerdasan buatan ke aplikasi And'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan kemampuan <b>presentasi efektif, manajemen waktu dan prioritas</b>, serta dasar-dasar <b>pengambilan keputusan dan personal branding</b>.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_jwt.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_newrelic.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_openai.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        },
        {
          id: 4, title: 'Proyek Akhir & Persiapan Karir', desc: 'Anda akan menerapkan semua pengetahuan dalam <b>proyek full-stack end-to-end</b>, dan mempersiapkan diri untuk karir profesional. Sehingga dalam fase ini anda dapat membangun Proyek full-stack mandiri, portofolio kerja yang kuat, pemahaman cloud computing yang solid, dan kesiapan penuh untuk memasuki dunia kerja sebagai Full-Stack Developer.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'All Stack', desc: 'Anda akan merencanakan, mengembangkan, dan mendeploy sebuah aplikasi full-stack yang kompleks, mengintegrasikan semua skill Go dan Vue.js yang telah dipelajari.'
                  },
                  // {
                  //   id: 2, title: 'Alibaba Cloud Associate (ACA)', desc: 'Mempelajari konsep cloud computing fundamental dan layanan utama Alibaba Cloud (ECS, RDS, OSS, VPC, dll.) yang relevan untuk deployment aplikasi. Pengetahuan ini akan langsung diaplikasikan dalam proses deployment proyek akhir Anda ke Alibaba Cloud. Anda akan dipersiapkan untuk ujian sertifikasi ACA.'
                  // },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Membuat <b>portofolio digital</b> yang menarik dan memahami strategi <b>pengembangan karir</b> jangka panjang.'
                  }
                ]
              }
            ],
          },
          tools: [
            // {id: 1, img: '/img/bootcamp/tools/ic_alicloud.png'},
            {id: 1, img: '/img/bootcamp/tools/ic_docker.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        }
      ],
      questions: [],
      classDetail: {
        schedules: [],
      },
      instructor: [
        {
          image_url: "/img/class/main.png",
          name: "Nae Fiona Alderia",
          description: "Senior Software Developer di LazyCash Payment",
          linkedin_url: ""
        }
      ],
      alertErrMessage: "",
      isAlertErr: false,
      isRegistrantClose: false,
      expired: [],
      layout: "info-kelas",
    };
  },
  metaInfo() {
    return {
      title: `HiColleagues | ${this.classDetail.name}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.classDetail.meta_description}`
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `HiColleagues | ${this.classDetail.name}`
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `${this.classDetail.meta_description}`
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'index, follow'
        }
      ],
    }
  },
  computed: {
    menuPublicClass() {
      return this.$t('bootcampDetail.menuPublicClass').map((item, idx) => ({
        name: item.name,
        id: idx + 1,
        position: 0,
        layout: item.layout
      }));
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getFaq();
      this.getDetailClass();
    },
  },
  methods: {
    getCurriculum(cur) {
      this.tempCurriculums = this.curriculums[cur];
      this.curriculumActive = cur+1;
    },
    mappingHeightOfElement() {
      let point = this.$refs.ctn_head.clientHeight;
      this.menuPublicClass[0].position = point;
      point += this.$refs.overview.clientHeight;
      this.menuPublicClass[1].position = point;
      point += this.$refs.curriculum.clientHeight;
      this.menuPublicClass[2].position = point;
      point += this.$refs.taget_peserta.clientHeight;
      this.menuPublicClass[3].position = point;
      point += this.$refs.instructor.clientHeight;
      this.menuPublicClass[4].position = point;
      point += this.$refs.why_hicolleagues.clientHeight;
      this.menuPublicClass[5].position = point;
      point += this.$refs.timeline_belajar.clientHeight;
      this.menuPublicClass[6].position = point;
      point += this.$refs.faq.clientHeight;
      this.menuPublicClass[7].position = point;
    },
    clickActiveMenu(layout, position, menuName) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Menu Click - ${menuName} - Bootcamp Detail Page`,
        value: 1,
      });
      this.layout = layout;
      goTo(Number(position + 10));
    },
    openFaq(idx) {
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.questions[idx].title} - Bootcamp Detail Page`,
        value: 1,
      });
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=BOOTCAMP&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Free Consultation WhatsApp - ${this.classDetail.name} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    toDiscount(total_price) {
      if (total_price <= 0) {
        return "FREE";
      } else {
        var formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    goToCheckoutPage(i) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Register Now - ${this.classDetail.name} - Bootcamp Detail Page`,
        value: 1,
      });
      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.is_discount
          ? (this.classDetail.price - this.classDetail.discount_price)
          : this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: "BOOTCAMP_CLASS",
        schedule: this.classDetail.schedules,
        days: this.classDetail.days,
        methode: this.classDetail.method,
        category_id: this.classDetail.category_id,
      });
      localStorage.clear();
      localStorage.setItem("checkout", req);
      window.location.href = `/checkout/bootcamp?category=BOOTCAMP&slug_name=${this.$route.params.slug_name}&p=${i}`;
    },
    goToFaqPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Bootcamp Detail Page',
        value: 1,
      });
      this.$router.push('/faq');
    },
    toLink(link, batchNumber) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Offline Webinar Location - Batch ${batchNumber} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open(link, '_blank');
    },
    async getDetailClass() {
      try {
        const resp = await this.$http.get(`/v1/class-detail/${this.$route.params.slug_name}`);
        const data = resp.data.data.class_detail;
        this.instructor = [resp.data.data.instructor];
        this.classDetail = {
          ...data,
          summary_syllabus: data.summary_syllabus
            ? data.summary_syllabus.map((item) => ({
              ...item,
              show: true,
            }))
            : [],
        };
        // this.isRegistrantClose = new Date(this.classDetail.registration_close_date) <= new Date();
        setTimeout(() => {
          this.mappingHeightOfElement();
        }, 1000);
      } catch (error) {
        this.$router.push('/class/bootcamp');
      }
    },
    handleScroll() {
      this.menuPublicClass.forEach((item) => {
        if (item.position <= window.scrollY) {
          this.layout = item.layout;
        }
      });
    },
    formatDate(date) {
      return moment(date).format("dddd, DD MMMM YYYY");
    },
    formatDateInfo(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === "online") {
        return this.$i18n.locale === 'id' ? "Daring (via Zoom)" : "Online (via Zoom)";
      } else if (value.toLowerCase() === "offline") {
        return this.$i18n.locale === 'id' ? "Luring" : "Offline";
      } else {
        return value;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getDetailClass();
    this.getFaq();
    window.scrollTo(0, 0);
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style src="./DetailBootcamp.css" scoped></style>